import {useAllowedActions} from './useAllowedActions.ts';
import {isRbacAction} from '../config/rbac/actions.ts';

export const useAllowedItems = () => {

    const {allowedActions} = useAllowedActions()

    const filterAllowed = (items: { rbac?: string }[]) => {

        return items.filter(item => {

            // if no rbac is specified allow it
            if (typeof item.rbac === 'undefined') {
                return true;
            } else {
                // if rbac property is specified - evaluate it and return accordingly
                if (isRbacAction(item.rbac) && allowedActions.includes(item.rbac)) {
                    return true;
                }
                return false;

            }
        });

    };

    return {
        filterAllowed,
    };

};
